// @flow
import * as React from 'react';
import { Logo } from './Logo';
import { LayoutProps } from './LayoutProps';

export const Nav = (props: LayoutProps) => (
  <nav className="navbar navbar-expand-lg navbar-light navbar-stick-dark" data-navbar="sticky">
    <div className="container">

      <div className="navbar-left">
        <button className="navbar-toggler">&#9776;</button>
        <Logo {...props} inverse />
      </div>

      <section className="navbar-mobile">
        <h6 className="d-sm-none">Focus Tax</h6>
        <nav className="nav nav-navbar ml-auto">
          <a className="nav-link" href="admin@huanggangxinyuan.com"><i className="fa fa-envelope" />&nbsp;admin@huanggangxinyuan.com </a>
          <a className="nav-link" href="tel:07138381712"><i className="fa fa-phone" />&nbsp;0713 8381712</a>
          <a className="nav-link" target="blank" href="http://map.baidu.com/?newmap=1&s=inf%26uid%3Dcac5fc7639db14f32cb96de1%26wd%3D%E9%BB%84%E5%86%88%E4%BF%A1%E6%BA%90%26all%3D1%26c%3D&from=alamap&tpl=mapdots">
            <i className="fa fa-map-marker" />&nbsp;
            东门路12号
          </a>
        </nav>

        <span className="navbar-divider" />

      </section>
    </div>
  </nav>);


export default Nav;



// WEBPACK FOOTER //
// ./src/layouts/Nav.jsx